// extracted by mini-css-extract-plugin
export var heroBackground = "k_fp";
export var subCategory = "k_fq";
export var dot = "k_fr";
export var green = "k_fs";
export var blue = "k_ft";
export var black = "k_fv";
export var yellow = "k_fw";
export var red = "k_fx";